import { TextValue } from './text-value.interface';

export enum MessageCategory {
    NONE = 0,
    ACCOUNT = 1,
    ASSAY_DESIGN,
    ORDERS,
    STRAINS,
}

export const messageCategoryText: { [key in MessageCategory]: string } = {
    [MessageCategory.NONE]: '',
    [MessageCategory.ACCOUNT]: 'Account',
    [MessageCategory.ASSAY_DESIGN]: 'Assay Design',
    [MessageCategory.ORDERS]: 'Orders',
    [MessageCategory.STRAINS]: 'Strains',
};

export const messageCategories: TextValue[] = [
    { text: messageCategoryText[MessageCategory.NONE], value: MessageCategory.NONE },
    { text: messageCategoryText[MessageCategory.ACCOUNT], value: MessageCategory.ACCOUNT },
    { text: messageCategoryText[MessageCategory.ASSAY_DESIGN], value: MessageCategory.ASSAY_DESIGN },
    { text: messageCategoryText[MessageCategory.ORDERS], value: MessageCategory.ORDERS },
    { text: messageCategoryText[MessageCategory.STRAINS], value: MessageCategory.STRAINS },
];
